import { Close as ResetIcon } from "@mui/icons-material";
import { IconButton, Stack } from "@mui/material";
import type { FC } from "react";
import DatePickerV2 from "../../components/datePicker/DatePickerV2";
import dayjs, { ISO_DATE_FORMAT } from "../../dayjs";
import AgentSelect from "../../sharedComponents/agentSelect/AgentSelect";
import type { AgentCallsFilters } from "../useAdminFilters";
import { defaultAgentCallsFilters } from "../useAdminFilters";

interface Props {
  readonly filters: AgentCallsFilters;
  readonly onChange: (filters: AgentCallsFilters) => void;
}

const AgentCallsSearch: FC<Props> = ({ filters, onChange }) => {
  return (
    <Stack
      direction="row"
      spacing={2}
      sx={{
        alignItems: "center",
      }}
    >
      <AgentSelect
        label="Pracownik"
        agentId={filters.agentId}
        requirePhone
        onChange={(id) => onChange({ ...filters, agentId: id })}
      />
      <DatePickerV2
        label="Od"
        fullWidth
        value={filters.dateFrom ? dayjs(filters.dateFrom, ISO_DATE_FORMAT) : null}
        onChange={(d) => onChange({ ...filters, dateFrom: d?.format(ISO_DATE_FORMAT) ?? "" })}
      />
      <DatePickerV2
        label="Do"
        fullWidth
        value={filters.dateTo ? dayjs(filters.dateTo, ISO_DATE_FORMAT) : null}
        onChange={(d) => onChange({ ...filters, dateTo: d?.format(ISO_DATE_FORMAT) ?? "" })}
      />
      <IconButton color="inherit" onClick={() => onChange(defaultAgentCallsFilters())}>
        <ResetIcon />
      </IconButton>
    </Stack>
  );
};

export default AgentCallsSearch;
